enum PermitExecutedActions {
	None = 0,
	AutomaticApproval = 1,
	Reviewed = 2,
	MultipleOperations = 4,
	AutoRenew = 8
}

export default PermitExecutedActions;
